<ng-container *ngIf="numberPublications; else zeroPublications">
  <asax-result-table-search-table-cell-popover [text]="numberPublications?.toString()">
    <title *ngTemplateOutlet="publicationsTitle"></title>
    <content *ngTemplateOutlet="publicationsContent"></content>
  </asax-result-table-search-table-cell-popover>
</ng-container>

<ng-template #publicationsTitle>
  <i class="fa-light fa-book me-1"></i>Publications
</ng-template>

<ng-template #publicationsContent>
  <ngx-datatable class="result-table-popover material striped m-1"
                 [style.height.px]="numberPublications > 4 ? (4 * rowHeight) + headerHeight : (numberPublications * rowHeight) + headerHeight"
                 [columnMode]="ColumnMode.standard"
                 [headerHeight]="headerHeight"
                 [footerHeight]="0"
                 [rowHeight]="rowHeight"
                 [rows]="rows"
                 [sortType]="SortType.single"
                 [messages]="{emptyMessage: '', totalMessage: 'total'}"
                 [scrollbarH]="false"
                 [scrollbarV]="true"
                 [externalPaging]="true"
                 [externalSorting]="true"
                 [limit]="pageSizeLimit"
                 [count]="totalRows"
                 [sorts]="sortNgxDataTableProp"
                 (page)="onPage($event)"
                 (sort)="onSort($event)">
    <ngx-datatable-column name="BibCode" prop="bibCode" [width]="170">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <a publicationLink [bibCode]="value"></a>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Author" prop="firstAuthor" [width]="100"></ngx-datatable-column>
    <ngx-datatable-column name="Journal" prop="journal" [width]="100"></ngx-datatable-column>
    <ngx-datatable-column name="Year" prop="publicationYear" [width]="70"></ngx-datatable-column>
    <ngx-datatable-column name="Title" prop="title" [width]="300"></ngx-datatable-column>
  </ngx-datatable>
</ng-template>

<ng-template #zeroPublications>
  <span class="badge bg-light text-dark border border-dark w-100 fw-light"
        style="font-size: 11px">
   0
  </span>
</ng-template>
